import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ATableColumn',
    slots: Object,
    render() {
        return null;
    },
});
